module.exports = __webpack_public_path__ + "static/media/remember_10.5461e23e.png";